var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    {
      attrs: {
        show: _vm.bigLoading,
        rounded: "sm",
        "spinner-variant": "warning"
      },
      scopedSlots: _vm._u([
        {
          key: "overlay",
          fn: function() {
            return [
              _c("b-icon", {
                attrs: {
                  icon: "three-dots",
                  animation: "cylon",
                  scale: "8",
                  variant: "warning"
                }
              })
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      !_vm.isError
        ? _c(
            "div",
            [
              _c(
                "DxPieChart",
                {
                  attrs: {
                    id: "pie",
                    "data-source": _vm.data,
                    palette: "Bright"
                  }
                },
                [
                  _c(
                    "DxSeries",
                    {
                      attrs: {
                        "argument-field": _vm.argumentField,
                        "value-field": _vm.valueField
                      }
                    },
                    [
                      _c(
                        "DxLabel",
                        { attrs: { visible: true } },
                        [
                          _c("DxConnector", {
                            attrs: { visible: true, width: 1 }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("DxSize", { attrs: { height: 300 } })
                ],
                1
              )
            ],
            1
          )
        : _c("div", { staticClass: "error-box" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("dashboard.isError")))])
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bae0adfa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bae0adfa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Chart.vue
// module id = null
// module chunks = 